import {AbstractAdvanceFilter} from './abstract-advance-filter';

export class TriStateCheckboxAdvanceFilter extends AbstractAdvanceFilter {

    public getValueFromChange(event, param) {
        return event.value;
    }
}
